import { Form, Typography } from 'antd';
import React from 'react';

import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

const { Text } = Typography;

export const FormItem: React.FC<NTasksList.FormItemProps> = ({
  label,
  rules,
  name,
  children,
  require,
  dependencies,
  valuePropName,
  extra,
}) => {
  return (
    <div className="item-container">
      {label ? (
        <Text strong className={require ? 'label-require' : 'label'}>
          {label}
        </Text>
      ) : (
        ''
      )}
      <Form.Item
        rules={rules}
        name={name}
        dependencies={dependencies}
        valuePropName={valuePropName}
        extra={extra}
      >
        {children}
      </Form.Item>
    </div>
  );
};
